import { TelagriLogo } from '@assets/icons/TelagriLogo';
import PaymentErrorIcon from '@assets/images/paymentError.png';
import PaymentSuccessIcon from '@assets/images/paymentSuccess.png';
import useLanguageNavigate from '@hooks/useLanguageNavigate';
import { usePageTitle } from '@hooks/usePageTitle';
import { Button } from '@mui/material';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUsersStore } from 'services/users';

export default function Payment({ isSuccess }: { isSuccess: boolean }) {
	const { t } = useTranslation();
	const { navigateWithLanguage } = useLanguageNavigate();
	usePageTitle(isSuccess ? t('paymentSuccess') : t('paymentError'));

	const { user } = useUsersStore();
	const isFarmerPath = user?.role?.toLowerCase() === 'farmer';

	const [isProcessing, setIsProcessing] = useState(isSuccess);

	useEffect(() => {
		if (isSuccess) {
			const timer = setTimeout(() => {
				setIsProcessing(false);
			}, 5000);
			return () => clearTimeout(timer);
		}
	}, [isSuccess]);

	const config = {
		success: {
			message: t('paymentSuccess'),
			buttonText: t('goToRequestAndOffers'),
			onClick: () => {
				navigateWithLanguage('/farmer/view-offers');
			},
			img: PaymentSuccessIcon,
		},
		error: {
			message: t('paymentError'),
			buttonText: t('retry'),
			onClick: () => {
				navigateWithLanguage('/farmer/services/monitoring/packages');
			},
			img: PaymentErrorIcon,
		},
	};

	const { message, buttonText, img } = isSuccess ? config.success : config.error;

	return (
		<div className="flex flex-col items-center justify-center bg-[#FFF8F4] h-screen w-full space-y-6">
			<div className="w-full max-w-[282px]">
				<TelagriLogo />
			</div>
			<div className="flex flex-row w-full justify-center gap-[50px] items-center py-12">
				<div className="w-full h-full max-w-[72px]">
					<img src={img} alt="payment_status" />
				</div>
				<span
					className={classNames(
						'font-roboto text-3xl font-bold',
						isSuccess ? 'text-primary' : 'text-error'
					)}
				>
					{message}
				</span>
			</div>

			{!isSuccess && (
				<Button
					className="w-full max-w-xs"
					variant="contained"
					onClick={() =>
						navigateWithLanguage(isFarmerPath ? '/farmer/dashboard' : '/specialist/dashboard')
					}
				>
					{t('goBack')}
				</Button>
			)}

			<Button
				className="w-full max-w-xs"
				variant="contained"
				onClick={config[isSuccess ? 'success' : 'error'].onClick}
				disabled={isSuccess && isProcessing}
			>
				{isSuccess && isProcessing ? t('processing') : buttonText}
			</Button>
		</div>
	);
}
